import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Realmente solo toma 5 minutos?',
    a: "Sí, el protocolo está diseñado para ser un 'reinicio rápido', no un ejercicio largo."
  }, {
    q: '¿Necesito materiales caros?',
    a: 'Solo un papel, un bolígrafo y tu cronómetro.'
  }, {
    q: '¿Funciona para el TDAH severo?',
    a: 'Está diseñado específicamente para la estructura de pensamiento no lineal.'
  }, {
    q: '¿Es un libro de teoría?',
    a: 'No, es un manual de implementación inmediata.'
  }, {
    q: '¿Puedo hacerlo en la oficina?',
    a: 'Sí, es discreto y se puede aplicar en cualquier entorno.'
  }, {
    q: '¿Qué pasa si me distraigo a mitad del proceso?',
    a: "El manual incluye un protocolo de 'reentrada' para esos momentos."
  }];
  return <section className="py-20 relative bg-black/20 border-t border-white/5" data-id="element-24">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-25">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-50 mb-12 text-center" data-id="element-26">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-27">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-28" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden transition-colors hover:bg-white/[0.07]" data-id="element-29">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-30">
        <span className="font-semibold text-slate-200 pr-4" data-id="element-31">{question}</span>
        <ChevronDownIcon className={`w-5 h-5 text-cyan-500 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-32" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-33">
        <p className="text-slate-400" data-id="element-34">{answer}</p>
      </div>
    </div>;
}